export const createPlanStatePoller = ({
  getPlanId, getState, refresh, isActive, setTimer = setTimeout, clearTimer = clearTimeout,
}) => {
  let timer = null;
  let generation = 0;
  let isRunning = false;
  let isChecking = false;
  let version = null;
  let pollSeconds = 60;
  let lastCheckAt = 0;
  let check;

  const cancelTimer = () => {
    if (timer !== null) clearTimer(timer);
    timer = null;
  };

  const schedule = () => {
    cancelTimer();
    if (isRunning && pollSeconds > 0) timer = setTimer(check, pollSeconds * 1000);
  };

  check = async () => {
    if (!isRunning || isChecking || !isActive()) return;
    cancelTimer();
    const requestGeneration = generation;
    const planId = getPlanId();
    const isCurrent = () => isRunning && generation === requestGeneration && getPlanId() === planId;
    isChecking = true;
    lastCheckAt = Date.now();

    try {
      const state = await getState(planId);
      if (!isCurrent()) return;
      pollSeconds = state.poll_seconds;
      if (pollSeconds === 0) return;
      if (version !== state.version) {
        await refresh(state, isCurrent);
        if (isCurrent()) version = state.version;
      }
    } catch (error) {
      if (isCurrent()) console.error('Не удалось обновить состояние CRM-планировки', error);
    } finally {
      if (generation === requestGeneration) {
        isChecking = false;
        schedule();
      }
    }
  };

  const stop = () => {
    isRunning = false;
    isChecking = false;
    generation += 1;
    cancelTimer();
  };

  const start = () => {
    stop();
    isRunning = true;
    version = null;
    pollSeconds = 60;
    if (isActive()) check();
    else schedule();
  };

  const activate = () => {
    if (pollSeconds > 0 && Date.now() - lastCheckAt >= 1000) check();
  };

  return { start, stop, activate };
};
